import $ from 'jquery';

export default class {
    constructor() {
        this.init();
    }

    init() {
        // define needed DOM nodes
        var $sectionSelector = $('.section-selector');

        // attach actions to DOM nodes
        $sectionSelector.click(() => {
            this.updateState($(event.currentTarget));
        });

        // this.updateState($('.section-selector.schedule-section-selector'));
        $sectionSelector.each((index, section) => {
            
            // Ensure 'how to make' section is open by default
            if ( ! $(section).hasClass('how-to-make')) {
                this.updateState($(section));
            }
        });
    }

    updateState(section) {
        // console.log(section);
        // console.log(section.hasClass('.tasty-section-selector'));
        
        if (!$(section).hasClass('in-active')) {
            $(section).addClass('in-active');
            // section.find('.content').slideUp();
            $(section).next().slideUp();
        } else {
            $(section).removeClass('in-active');
            // section.find('.content').slideDown();
            $(section).next().slideDown();
        }
    }
}



// WEBPACK FOOTER //
// ./scripts/modules/SectionSelector.js